import React, { useEffect, useState } from 'react';
import cx from 'classnames';

export type LoadingProps = {
  progressText?: string;
  delayedText?: string;
  className?: string;
  showDelayMs?: number;
  showDelayedTextMs?: number;
};

export const Loading: React.FC<LoadingProps> = ({
  progressText = 'Loading...',
  delayedText = 'This can take up to a minute, please be patient',
  className,
  showDelayMs = 2000,
  showDelayedTextMs = 10000,
}) => {
  const [showLoading, setShowLoading] = useState(false);
  const [showCouldBeWhile, setShowCouldBeWhile] = useState(false);

  useEffect(() => {
    const loadingTextTimer = setTimeout(() => {
      setShowLoading(true);
    }, showDelayMs);

    const loadingText2Timer = setTimeout(() => {
      setShowCouldBeWhile(true);
    }, showDelayedTextMs);

    return () => {
      clearTimeout(loadingTextTimer);
      clearTimeout(loadingText2Timer);
    };
  }, [showDelayMs, showDelayedTextMs]);

  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center min-h-screen',
        className
      )}
    >
      {/* Spinner container */}
      <div className="relative">
        {/* Outer ring */}
        <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
        {/* Animated ring */}
        <div className="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-primary-500 rounded-full animate-spin"></div>
      </div>

      {/* Text container with fixed height to prevent layout shift */}
      <div className="mt-6 h-20 flex flex-col items-center justify-start gap-2">
        <div
          className={cx(
            'text-base font-medium text-foreground-secondary text-center transition-opacity duration-300',
            showLoading ? 'opacity-100' : 'opacity-0'
          )}
        >
          {progressText}
        </div>
        <div
          className={cx(
            'text-sm text-muted-foreground text-center transition-opacity duration-300',
            showCouldBeWhile ? 'opacity-100' : 'opacity-0'
          )}
        >
          {delayedText}
        </div>
      </div>
    </div>
  );
};
